import { type IResponse, encryptedRequest } from "../core/api.client";
import { API_PATHS } from "../constants/api-paths";

export interface IBrokerDetailsRequest {
  brokerId: string;
}

export interface IBrokerdetailsResponse {
  brokerid: string;
  brokername: string;
  brokertype: string;
  typeOfPartner: string;
  brokeremail: string;
  brokermobile: string;
  partneraddress: string;
}

export const getBrokerDetails = async (
  data: IBrokerDetailsRequest
): Promise<IResponse<IBrokerdetailsResponse> | null> => {
  try {
    const response = await encryptedRequest<IBrokerdetailsResponse>({
      method: "POST",
      url: API_PATHS.brokerdetails,
      data,
    });
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
